<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .hd-left{
        display: inline-block;
        position: absolute;
        left: 10px;
        top:0;
        color: #000;
        font-size: 16px;
    }
    .hd-right{
        text-align: right;
        color: #000;
        position: absolute;
        right: 10px;
        top:0;
    }
    .title{
        background: none;
        text-align: center;
        font-size: 18px;
        color: #000;
    }
    header{
        background: #fff;
        padding: 0 5%;
        line-height: 48px;
        border-bottom: 1px solid #dfdfdf;
        position: fixed;
        width: 100%;
        height: 48px;
        top:0;
        -webkit-box-shadow: 0 2px 4px rgba(225,225,225,0.50);
        -moz-box-shadow: 0 2px 4px rgba(225,225,225,0.50);
        box-shadow: 0 2px 4px rgba(225,225,225,0.50);
        z-index: 55;
    }
</style>
<template>
    <header class="clearfix">
        <div class="hd-right">
             <slot name="right"></slot>
        </div>
        <div class="hd-left">
            <slot name="left"></slot>
        </div>
        <h5 class="title" @click="toGo">
            <slot name="title"></slot>
        </h5>
    </header>
</template>
<script>
    export default {
        name: '',
        data() {
            return {
                title:document.title,
                rights:'',
                lefts:'',
            }
        },
        props: ['left','right','titles','events'],
        methods: {
            toGo () {
                if(this.hrefs){
                    window.location.href = this.hrefs
                }
            }
        },
        components: {},
        mounted() {
            this.$nextTick(function() {
            })
        },
        created() {
        }
    }
</script>


// WEBPACK FOOTER //
// heads.vue?1ebad412